<template>
  <div>
    <simple-toolbar>
      <md-button class="md-dense md-raised md-primary" @click="add()">{{
        C('add')
      }}</md-button>
    </simple-toolbar>

    <md-content>
      <md-table v-model="userIPs" md-stripe md-fixed-header>
        <md-table-empty-state :md-label="L('allowAllIP')" />
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell :md-label="L('seq')">{{ item.seq }}</md-table-cell>
          <md-table-cell :md-label="'IP'">{{ item.ip }}</md-table-cell>
          <md-table-cell :md-label="L('description')">{{
            item.description
          }}</md-table-cell>
          <md-table-cell :md-label="L('action')">
            <md-button
              class="md-icon-button md-dense"
              @click="modify(item.seq)"
            >
              <fa-icon icon="pencil-alt" />
            </md-button>
            <md-button
              class="md-icon-button md-dense"
              @click="openRemoveDialog(item)"
            >
              <fa-icon icon="trash-alt" />
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-content>

    <!-- main dialog -->
    <md-dialog
      :md-active.sync="dialog.show"
      v-if="dialog.show"
      class="md-dialog-big"
    >
      <md-dialog-title>{{ dialog.title }}</md-dialog-title>

      <md-dialog-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field :class="`${validation.ip ? 'md-invalid' : ''}`">
              <label>IP</label>
              <md-input v-model="dialog.item.ip" required />
              <md-button @click="getPublicIp()" class="md-icon-button">
                <md-icon>place</md-icon>
              </md-button>
            </md-field>
            <p>
              {{
                `${L('example')}) 133.32.128.249 ${L('or')} 133.32.128.249/32`
              }}
            </p>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>{{ L('description') }}</label>
              <md-input v-model="dialog.item.description" />
            </md-field>
          </div>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="close()">{{
          L('cancel')
        }}</md-button>
        <md-button class="md-primary md-raised" @click="save()">{{
          L('save')
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- remove dialog -->
    <md-dialog-confirm
      :md-active.sync="dialog.remove"
      :md-title="L('removeAllowedIp')"
      :md-content="`${L('confirmRemove')}? ${dialog.item.ip} (${
        dialog.item.seq
      })`"
      :md-confirm-text="L('remove')"
      :md-cancel-text="L('cancel')"
      @md-confirm="remove(dialog.item.seq)"
    />
  </div>
</template>

<script>
import SimpleToolbar from '@/views/layout/SimpleToolbar'
import { mapState } from 'vuex'
import api from '@/api'

export default {
  components: { SimpleToolbar },

  data: () => ({
    userIPs: [],
    dialog: {
      show: false,
      modify: false,
      remove: false,
      title: '',
      item: {},
    },
    validation: {
      ip: false,
    },
  }),

  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },

  watch: {
    userInfo() {
      this.load()
    },
  },

  mounted() {
    if (this.userInfo.seq !== undefined) {
      this.load()
    }
  },

  methods: {
    async load() {
      this.close()
      this.userIPs = await api.userIp.list(this.userInfo.seq)
    },

    add() {
      this.resetValidate()
      this.dialog.show = true
      this.dialog.title = this.L('addAllowedIp')
      this.dialog.item = {}
    },

    close() {
      this.dialog.show = false
      this.dialog.modify = false
      this.dialog.title = ''
      this.dialog.item = {}
    },

    async save() {
      if (!this.validate(this.dialog.item)) return

      if (this.dialog.modify) {
        await api.userIp.modify(this.dialog.item.seq, this.dialog.item)
      } else {
        await api.userIp.add(this.userInfo.seq, this.dialog.item)
      }

      this.load()
    },

    async modify(seq) {
      api.userIp.get(seq).then((res) => {
        this.resetValidate()
        this.dialog.show = true
        this.dialog.modify = true
        this.dialog.title = this.L('modifyAllowedIp')
        this.dialog.item = {
          seq: res.seq,
          ip: res.ip,
          description: res.description,
        }
      })
    },

    openRemoveDialog(item) {
      this.dialog.item = item
      this.dialog.remove = true
    },

    async remove(seq) {
      api.userIp.remove(seq).then(() => {
        this.load()
      })
    },

    validate(item) {
      let validation = false
      this.validation.ip = true
      const ipRegex =
        /^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/

      if (item.ip && item.ip.length > 0 && ipRegex.test(this.dialog.item.ip)) {
        this.validation.ip = false
      }
      if (!this.validation.ip) {
        validation = true
      }

      return validation
    },

    resetValidate() {
      this.validation.ip = false
    },

    async getPublicIp() {
      const res = await fetch('https://api.ipify.org/?format=json')
      const { ip } = await res.json()
      this.dialog.item = {
        ...this.dialog.item,
        ip,
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
